class TooManyRequestExceptions extends Error {
    constructor(message) {
      super(message);
      this.name = 'TooManyRequestExceptions';
    }
  }
  
export default TooManyRequestExceptions;